module.exports = "/images/blog-author.png?07182fea92c7fa9827a03c2609544df7";